<template>
  <v-container fluid class="containerBig">
    <v-dialog v-model="dialog" hide-overlay>
      <v-card v-if="dItem != null">
        <v-card-title class="headline">
          <span> {{dItem.Time}} - {{dItem.Type}}</span>
          <v-spacer></v-spacer>
          <v-btn @click="dialog = false" flat icon color="#004884"><v-icon>clear</v-icon></v-btn>
        </v-card-title>
          <v-container>
            <v-layout row wrap>
              <v-flex md12 style="text-align:left">
                <div style="overflow:auto;height: 400px; width: 100%;"class="preClass" v-html="dialogText">
                </div>
              </v-flex>


            </v-layout>
          </v-container>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="darken-1" flat @click="dialog = false">{{ 'BUTT_CLOSE' | translate}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-layout row wrap justify-center class="">
      <v-flex xs12 sm12 md12 lg12>
        <v-card>
          <v-system-bar height="32" dense
                        class="myCardTitleColor verlauf abstandunten04"
          >
            <v-spacer></v-spacer>
            <v-toolbar-title class="toolbarWhite">{{ 'TITLE_ADMIN_LOG' | translate}}</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-system-bar>
          <v-select v-model="logFilter"
                    :items="logs"
                    label="Filter"
                    @change="reload"
          ></v-select>
          <v-data-table
            :headers="headers"
            :items="tableData"
            :pagination.sync="pagination"
            item-key="name"
            class="peerTable"
          >
            <template slot="headers" slot-scope="props">
              <tr>
                <th
                  v-for="header in props.headers"
                  :key="header.text"
                  :class="['column text-xs-left sortable ' + getHeaderClass(header), pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
                  :width="header.width"
                  @click="changeSort(header.value)"
                >
                  {{ header.text }}
                  <v-icon small>arrow_upward</v-icon>
                </th>
              </tr>
            </template>
            <template slot="items" slot-scope="props">
              <tr :active="props.selected">
                <td :class="getClassFor(header)" v-for="header in headers" :key="header.id" :width="header.width" @click="showDialog(props.item,header.id)">
                  <v-checkbox v-if="header.value === 'email'" label='' v-model='props.item.isEmail'
                              @change="saveEmailNotification(props.item)"></v-checkbox>
                  <span v-if="header.value != 'email'" v-html="getValue(props.item, header)"></span>
                </td>
              </tr>
            </template>
            <!--
            <template slot="expand" slot-scope="props">
              <v-card flat>
                <v-card-text>Peek-a-boo!</v-card-text>
              </v-card>
            </template>
            -->
          </v-data-table>
        </v-card>
        <br><br><br><br>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Vue from 'vue'

export default {
  name: 'AdminLog',
  data () {
    return {
      isAdmin: false,
      ankerBank: null,
      hasAnkerBank: false,
      dItem: null,
      dialogText: '',
      logFilter: 'SQL',
      logs: ['JSON', 'SQL', 'EXCEPTION_JS', 'TEXT', 'PARAM', 'RESULT', 'ERROR', 'CRON', 'ALL'],
      emailSet: [
        {text: 'Ja', id: '1'},
        {text: 'Nein', id: '0'}
      ],
      dialog: false,
      headers: [
        {text: Vue.i18n.translate('CELL_TITLE_ID'), id:'id', value: 'ID', width: 40},
        {text: Vue.i18n.translate('CELL_TITLE_TIME'), id:'time', value: 'Time', width: 200},
        {text: Vue.i18n.translate('CELL_TITLE_FILE'), id:'file', value: 'File', width: 180},
        {text: Vue.i18n.translate('CELL_TITLE_LINE'), id:'line', value: 'Line', width: 60},
        {text: Vue.i18n.translate('CELL_TITLE_TEXT'), id:'text', value: 'Text'}
      ],
      crefoDoubleExists: false,
      pagination: {
        rowsPerPage: 5,
        descending: true,
        sortBy: 'ID'
      },
      tableData: [],
      countries: []
    }
  },
  methods: {
    syntaxHighlight: function (json) {
      if (typeof json != 'string') {
        json = JSON.stringify(json, undefined, 4);
      }
      json = json.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;<br>').replace(/}/g, '}<br>').replace(/,/g, ',<br>');
      return json.replace(/("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g, function (match) {
        var cls = 'number';
        if (/^"/.test(match)) {
          if (/:$/.test(match)) {
            cls = 'key';
          } else {
            cls = 'string';
          }
        } else if (/true|false/.test(match)) {
          cls = 'boolean';
        } else if (/null/.test(match)) {
          cls = 'null';
        }
        return '<span class="' + cls + '">' + match + '</span>';
      })
    },

    showDialog (item, headerId) {
      if (headerId === 'text') return
      this.dialog = true
      this.dItem = item
      this.dialogText = this.syntaxHighlight(this.dItem.Text)

      Vue.prototype.$api.debug('dialog', item)
    }
    ,
    restart () {
      // window.location = '/rating/displayApplicationsOrApplicationAreas.php?AppNr=161'
      window.location = Vue.prototype.storage.appConfig.RESET_URL
    }
    ,
    onGetChangelogs: function (data) {
      Vue.prototype.$api.debug('onGetChangelogs', data)
      this.tableData = []
      Vue.prototype.$api.hideIdle()
      if (!data.array) {
        return
      }
      this.tableData = data.array
      for (var index in this.tableData) {
        var item = this.tableData[index]
        item.isEmail = item.email === '1'
      }
    }
    ,
    onGetUpdate (data) {
      Vue.prototype.$api.debug('onGetUpdate')
      Vue.prototype.$api.hideIdle()
      this.onChangeLogs()
    }
    ,
    changeSort (column) {
      Vue.prototype.$api.debug('change sort', column)
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.sortBy = column
        this.pagination.descending = false
      }
    }
    ,
    getValue (item, _header) {
      var value = item[_header.value]
      if (_header.value === 'File') {
        if (value) {
          var index = value.lastIndexOf('\\')
          if (index > -1) {
            index += 1
          } else {
            index = value.lastIndexOf('/') + 1
          }
          value = value.substring(index)
        }
      }
      return value
    }
    ,
    getHeaderClass (header) {
      if (header.value === 'balanceSum') {
        return 'text-xs-right'
      }
      return 'text-xs-left'
    }
    ,
    getClassFor (header) {
      if (header.value === 'balanceSum') {
        return 'text-xs-right'
      }
      return 'text-xs-left'
    }
    ,
    reload: function () {
      this.onChangeLogs()
    }
    ,
    onChangeLogs: function () {
      Vue.prototype.$api.showIdle()
      Vue.prototype.$api.getAdminLogs(this.logFilter, this.onGetChangelogs)
    }
  },
  mounted () {
    var cmp = this
    cmp.onChangeLogs()
    Vue.prototype.$api.getBreadCrumpModule({id: 'admin', text: 'Administration', href: '/#/di/Administration'})
    this.isAdmin = Vue.prototype.$api.isAdmin()
  }
}
</script>

<style scoped>
  .preClass {outline: 1px solid #ccc; padding: 5px; margin: 5px; }
  .string { color: green; }
  .number { color: darkorange; }
  .boolean { color: blue; }
  .null { color: magenta; }
  .key { color: red; }

</style>



// WEBPACK FOOTER //
// src/components/admin/AdminLog.vue